import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { backofficeApi } from '@/lib/backoffice-api'
import type { ResetRequest, ResetRequestStatus, ResolveResetRequestResult } from '@/types/backoffice'

const KEYS = {
  list: (status?: ResetRequestStatus) => ['backoffice', 'reset-requests', status ?? 'all'] as const,
}

export function useResetRequests(status: ResetRequestStatus = 'PENDING') {
  return useQuery({
    queryKey: KEYS.list(status),
    queryFn: () =>
      backofficeApi
        .get<{ data: ResetRequest[] }>('/backoffice/password-reset-requests', { params: { status } })
        .then((r) => r.data.data),
  })
}

export function useResolveResetRequest() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      backofficeApi
        .patch<ResolveResetRequestResult>(`/backoffice/password-reset-requests/${id}/resolve`)
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['backoffice', 'reset-requests'] }),
  })
}

export function useIgnoreResetRequest() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      backofficeApi
        .patch(`/backoffice/password-reset-requests/${id}/ignore`)
        .then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['backoffice', 'reset-requests'] }),
  })
}
